import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/lib/auth/auth-context'
import { BiscuitTiny } from '@/components/biscuit/BiscuitTiny'

interface ProtectedRouteProps {
  children: ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div
        role="status"
        aria-live="polite"
        aria-label="Checking your session"
        className="min-h-dvh flex flex-col items-center justify-center gap-3"
      >
        <div className="animate-bounce motion-reduce:animate-none">
          <BiscuitTiny mood="happy" size={56} />
        </div>
        <p className="text-sm text-muted-foreground">Biscuit's checking your collar…</p>
      </div>
    )
  }


  if (!user) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
